import { Phone, Snowflake, Droplets } from "lucide-react";

const month = new Date().getMonth();
const isWinter = month >= 9 || month <= 3;
const banner = isWinter
  ? {
      icon: Snowflake,
      text: "Winter season — lock in your snow plow contract: $800–$1,200 per season",
      cta: "Book Now",
      testid: "seasonal-banner-winter",
    }
  : {
      icon: Droplets,
      text: "Summer season — power washing & junk removal spots filling fast",
      cta: "Get a Quote",
      testid: "seasonal-banner-summer",
    };

export default function Navbar() {
  return (
    <header data-testid="navbar" className="fixed top-0 inset-x-0 z-50">
      <div data-testid={banner.testid} className="bg-[#F59E0B] text-black px-6 py-2 flex items-center justify-center gap-2 text-center">
        <banner.icon className="w-4 h-4 shrink-0" strokeWidth={2.5} />
        <span className="text-xs sm:text-sm font-bold tracking-wide">{banner.text}</span>
        <a data-testid="seasonal-banner-cta" href="#quote" className="text-xs sm:text-sm font-bold underline underline-offset-2 hover:no-underline ml-1">{banner.cta}</a>
      </div>
      <div className="bg-black/70 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo.png" alt="Ultimate Warrior Junk and Plow Removal logo" className="h-16 w-auto drop-shadow-[0_0_12px_rgba(0,0,0,0.6)]" />
        </a>
        <nav className="hidden md:flex items-center gap-8 text-xs tracking-[0.2em] uppercase font-bold text-neutral-300">
          <a data-testid="nav-services-link" href="#services" className="hover:text-[#F59E0B] transition-colors duration-200">Services</a>
          <a data-testid="nav-reviews-link" href="#reviews" className="hover:text-[#F59E0B] transition-colors duration-200">Reviews</a>
          <a data-testid="nav-quote-link" href="#quote" className="hover:text-[#F59E0B] transition-colors duration-200">Free Quote</a>
        </nav>
        <a
          data-testid="nav-call-button"
          href="tel:+14165086931"
          className="flex items-center gap-2 bg-[#F59E0B] text-black font-display text-xl tracking-wider px-5 py-2.5 hover:bg-[#D97706] transition-colors duration-200 active:scale-95"
        >
          <Phone className="w-4 h-4" strokeWidth={2.5} />
          <span className="hidden sm:inline">416-508-6931</span>
          <span className="sm:hidden">CALL</span>
        </a>
      </div>
      </div>
    </header>
  );
}
